/* eslint-disable prettier/prettier */
import React from 'react';
import { ScheduleViewMode } from '../../types/schedule.types';
import styles from '../../styles/Schedule/ViewModeToggle.module.css';

interface ViewModeToggleProps {
	viewMode: ScheduleViewMode;
	onChange: (mode: ScheduleViewMode) => void;
}

const MODES: { id: ScheduleViewMode; label: string }[] = [
	{ id: 'week', label: 'Week' },
	{ id: 'month', label: 'Month' },
];

const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
	viewMode,
	onChange,
}) => (
	<div
		className={styles.toggle}
		role="tablist"
		aria-label="Schedule view mode"
	>
		{MODES.map(mode => (
			<button
				key={mode.id}
				role="tab"
				aria-selected={viewMode === mode.id}
				className={`${styles.option} ${viewMode === mode.id ? styles.optionActive : ''}`}
				onClick={() => onChange(mode.id)}
			>
				{mode.label}
			</button>
		))}
	</div>
);

export default ViewModeToggle;
